import { organizationDemoPeriodStatusesEnum } from "helpers/enums";
import { useEffect, useState } from "react";
import SignalRConnection from "services/signalRConnection";

export function useDemoPeriod(organization, profile, getOrg, { suppressAutoShow = false } = {}) {
    const [daysRemaining, setDaysRemaining] = useState(organization?.demoPeriod?.daysRemaining ?? null);
    const [showExpiringModal, setShowExpiringModalState] = useState(false);
    const isChiefAdmin = profile.id === organization.adminId;
    const hasDocument = organization?.demoPeriod?.hasDocument;
    const status = organization?.demoPeriod?.status;

    const setShowExpiringModal = (value) => {
        if (!isChiefAdmin) {
            return;
        }
        setShowExpiringModalState(value);
    };

    useEffect(() => {
        if (!organization?.demoPeriod) {
            return;
        }

        const status = organization.demoPeriod.status;

        setDaysRemaining(organization.demoPeriod.daysRemaining);

        if (isChiefAdmin && !suppressAutoShow) {
            if (
                status === organizationDemoPeriodStatusesEnum.Expired ||
                (status === organizationDemoPeriodStatusesEnum.Active && organization.demoPeriod.isDemoPeriodExpiring)
            ) {
                setShowExpiringModal(true);
            }
        }

        const token = localStorage.getItem("token");
        if (!token) {
            return;
        }

        const connection = new SignalRConnection({
            url: "/signalr/organizations",
            actions: [
                { name: "SendDemoPeriodDaysRemaining", action: (days) => setDaysRemaining(days) },
                {
                    name: "SendDemoPeriodExpiring",
                    action: () => {
                        if (getOrg) {
                            getOrg();
                        }
                        if (isChiefAdmin && !suppressAutoShow) {
                            setShowExpiringModal(true);
                        }
                    },
                },
                {
                    name: "SendDemoPeriodExpired",
                    action: () => {
                        if (getOrg) {
                            getOrg();
                        }
                        if (isChiefAdmin && !suppressAutoShow) {
                            setShowExpiringModal(true);
                        }
                    },
                },
            ],
            joinActionName: "Join",
            leaveActionName: "Leave",
        });

        return () => {
            connection.disconnect();
        };
    }, [organization?.demoPeriod, profile?.id, organization?.adminId, suppressAutoShow]);

    return {
        daysRemaining,
        showExpiringModal,
        setShowExpiringModal,
        hasDocument,
        status,
    };
}
